export default __webpack_public_path__ + "static/media/03-healthcare_preview.d2f1e3ab.jpg";